// Two toast systems exist in this codebase — pick the right one for the context:
//
//   postToast (this function)
//     Posts a {action:'toast'} postMessage to the downstroke parent frame.
//     Use for page-level feedback visible outside the iframe: data load failures
//     (isError effects), accordion form submission results, mutation outcomes.
//     No-ops silently when running standalone (window.parent === window).
//
//   useToastNotification  (features/common/hooks/useToastNotification)
//     Renders a toast inside the iframe itself.
//     Use for narrow, in-context feedback that does not need to surface above the
//     frame boundary — e.g. clipboard copy confirmation in SeatsSection.
//
// Rule of thumb: if the user's eye is on the parent frame when the event fires,
// use postToast. If focus stays inside the iframe widget, use useToastNotification.

export const postToast = (variant: 'success' | 'error', title: string, description?: string): void => {
	if (window.parent === window) return;
	window.parent.postMessage(
		{ action: 'toast', variant, title, description },
		process.env.REACT_APP_DOWNSTROKE_PORTAL_URL || '*'
	);
};
